import { useContext, useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { UserContext } from "../amplify/authenticator-provider";
import { GET_MESSAGE_FORWARD_OPTIONS } from "../graphql/query";
import { isAllLocationSelected } from "../library/helpers";

const defaultOptions = {
  isForwardEmail: false,
  isForwardNotification: false,
  isForwardSms: false,
};

const useMessageForwardOptions = () => {
  const [forwardOptions, setForwardOptions] = useState({});
  const [hasAnyForwardOption, setHasAnyForwardOption] = useState(false);

  const { user } = useContext(UserContext);
  const companyId = user?.company?.id;
  const locationId = isAllLocationSelected()
    ? user?.location?.id
    : sessionStorage.getItem("currentLocationId");

  const { loading, error, data, refetch } = useQuery(GET_MESSAGE_FORWARD_OPTIONS, {
    variables: { companyId: +companyId, locationId: +locationId },
    skip: !companyId || !locationId,
    onCompleted: data => {
      const opts = data?.getMessageForwardOptions || {};
      const keyed = Object.keys(opts).length
        ? Object.fromEntries(Object.entries(opts).map(([k, v]) => [k, !!v]))
        : defaultOptions;
      setForwardOptions(keyed);
    },
  });

  // Update hasAnyForwardOption whenever forwardOptions change
  useEffect(() => {
    const hasAnyOption = Object.values(forwardOptions).some(value => value === true);
    setHasAnyForwardOption(hasAnyOption);
  }, [forwardOptions]);

  return {
    forwardOptions,
    hasAnyForwardOption,
    loading,
    error,
    refetch,
  };
};

export default useMessageForwardOptions;
